import LicensePlate from '@rio-cloud/rio-uikit/components/licensePlate/LicensePlate';
import type { Asset } from '../domain/model/assets.types';

type LicensePlateCellProps = {
    asset: Asset;
    maxWidth?: number | null | undefined;
};

export const LicensePlateView = ({ asset, maxWidth }: LicensePlateCellProps) => (
    <div className='width-100pct' style={{ maxWidth: maxWidth ?? 130 }}>
        {asset.licensePlate && (
            <LicensePlate countryCode={asset.licensePlateCountryCode}>{asset.licensePlate}</LicensePlate>
        )}
    </div>
);
